import { StyleSheet } from 'react-native';

const DashboardBannerSMImage = ({ style }) => {
  const oneX = require('./dashboard-banner-sm.jpg');
  const twoX = require('./dashboard-banner-sm@2x.jpg');
  return (
    <img
      src={twoX}
      alt=""
      style={{ ...StyleSheet.flatten(style), objectFit: 'cover' }}
      srcSet={`${oneX}, ${twoX} 2x`}
    />
  );
};

export { DashboardBannerSMImage };
